import script from "./OrderShowPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderShowPayment.vue?vue&type=script&setup=true&lang=js"

import "./OrderShowPayment.vue?vue&type=style&index=0&id=843a75d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-843a75d0"]])

export default __exports__